/**
 * useUserLog — the public hook for emitting user-log events from any component.
 *
 * Example:
 *   const { logEvent } = useUserLog();
 *   logEvent({ action: LogAction.BUTTON_CLICK, properties: { button: "save" } });
 *
 * Never blocks, never throws. Safe to call during render (it's just a stable
 * reference to the singleton client).
 */

import { useCallback } from "react";
import { userLogClient } from "./userLogClient";
import type { UserLogEventInput } from "./types";

export const useUserLog = () => {
	const logEvent = useCallback((event: UserLogEventInput) => {
		userLogClient.logEvent(event);
	}, []);

	return { logEvent };
};
